<template>
<update-base>
    <div v-if="has_error" v-text="error_text" class="alert alert-danger mb-4"></div>
    <div v-if="!has_created_request">
        <div class="d-flex align-items-center justify-content-between">
            <div class="w-50">
                <label for="add_stakeholder" v-text="$t('stakeholders.label.add_stakeholder_to_shop')"></label>
                <select id="add_stakeholder"
                        name="add_stakeholder"
                        v-model="new_stakeholder"
                        @change="add_new_stakeholder()"
                        class="form-control kt-selectpicker">
                    <option v-for="(item, index) in all_stakeholders" :key="index" :value="item">
                        <span>{{ item.full_name }} ({{ item.id }})</span>
                    </option>
                </select>
            </div>
            <div>
                <button type="button" class="btn btn-success" v-text="$t('btn.send_request')" @click="sync_shop_stakeholders()"></button>
            </div>
        </div>
    </div>
    <div v-else class="alert alert-info my-3" v-text="$t('stakeholders.label.you_have_pending_request')"></div>
    <div class="line-divider mt-4 mb-3"></div>
    <div class="text-center">
        <table class="table">
            <thead>
                <tr>
                    <th v-text="$t('label.identifier')" class="bg-white"></th>
                    <th v-text="$t('label.full_name')" class="bg-white"></th>
                    <th v-text="$t('label.phone')" class="bg-white"></th>
                    <th v-text="$t('label.sheba_numbers')" class="bg-white"></th>
                    <th v-text="$t('label.merchant_type')" class="bg-white"></th>
                    <th v-text="$t('label.status')" class="bg-white"></th>
                    <th v-text="$t('label.attachment_status')" class="bg-white"></th>
                    <th v-if="!has_created_request" v-text="$t('datatable.actions')" class="bg-white"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in stakeholders" :key="index">
                    <td v-text="item.id"></td>
                    <td v-text="item.full_name"></td>
                    <td v-text="item.cellphone_number"></td>
                    <td>
                        <!-- Button trigger modal -->
                        <button type="button" class="btn btn-info p-1" data-toggle="modal" :data-target="`#shebaModal${index}`">
                            <small v-text="$t('label.details')"></small>
                        </button>

                        <!-- Modal -->
                        <div class="modal fade" :id="`shebaModal${index}`" tabindex="-1">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <table class="table table-bordered">
                                            <tr>
                                                <td v-text="$t('label.identifier')"></td>
                                                <td v-text="$t('label.sheba_number')"></td>
                                            </tr>
                                            <tr v-for="(item, sheba_index) in item.sheba_numbers" :key="sheba_index">
                                                <td v-text="item.id"></td>
                                                <td v-text="item.number"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td v-text="merchant_type_str.get(item.merchant_type)"></td>
                    <td>
                        <span :class="`label label-inline label-light-${stakeholder_variant(item.status)}`" v-text="stakeholder_status_str.get(item.status)"></span>
                    </td>
                    <td>
                        <span :class="item.shop_attachment_status ? `label label-inline label-light-${stakeholder_shop_variant(item.shop_attachment_status)}` : null" v-text="stakeholder_shop_status_str.get(item.shop_attachment_status)"></span>
                    </td>
                    <td v-if="!has_created_request">
                        <button type="button" class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm" @click="deleteRow(index)">
                            <span class="tooltip-text">حذف</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#ff6060"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                            </span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</update-base>
</template>

<script>
import UpdateBase from './components/allotment-update-base';
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { stakeholdersService } from '@/common/api.service';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { stakeholderStatusStr, stakeholderVariant } from '@/constants/stakeholderStatus';
import { stakeholderShopStatusStr, stakeholderShopVariant } from '@/constants/StakeholderShopAttachmentStatus';

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            has_error: false,
            error_text: '',
            has_created_request: false,
            stakeholders: [],
            all_stakeholders: [],
            new_stakeholder: null,
            merchant_type: merchantType,
            merchant_type_str: merchantTypeStr,
            stakeholder_status_str: stakeholderStatusStr,
            stakeholder_variant: stakeholderVariant,
            stakeholder_shop_status_str: stakeholderShopStatusStr,
            stakeholder_shop_variant: stakeholderShopVariant,
        };
    },
    mounted() {
        stakeholdersService.get_dedicated_shop_stakeholders(this.$route.params.hashid).then(response => {
            this.has_created_request = response.data.data.has_created_request;
            this.stakeholders = response.data.data.stakeholders;
            
            stakeholdersService.get_all_dedicated_stakeholders().then(response => {
                this.all_stakeholders = response.data.data;
            }).finally(() => {
                this.init_select_picker();
            });
        });
    },
    methods: {
        add_new_stakeholder() {
            if (this.new_stakeholder != null && this.new_stakeholder != '') {
                this.stakeholders.push({
                    cellphone_number:   this.new_stakeholder.cellphone_number,
                    full_name:          this.new_stakeholder.full_name,
                    id:                 this.new_stakeholder.id,
                    merchant_type:      this.new_stakeholder.merchant_type,
                    status:             this.new_stakeholder.status,
                });
            }
        },
        sync_shop_stakeholders() {
            let stakeholders_ids = [];

            for(let i = 0; i < this.stakeholders.length; ++i) {
                stakeholders_ids.push(this.stakeholders[i].id);
            }

            let params = {
                selected_stakeholders: stakeholders_ids,
            };

            stakeholdersService.update_dedicated_shop_stakeholders(params, this.$route.params.hashid).then(response => {
                this.has_error = false;
                this.$router.push('/gateways');
            }).catch(() => {
                this.error_text = i18n.t('message.an_error_occurred');
                this.has_error = true;
            });
        },
        deleteRow(index) {
            this.stakeholders.splice(index, 1);
        },
        init_select_picker() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }
    },
}
</script>
